import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";
import React, { useEffect } from "react";
import Login from "./pages/Login";
import Home from "./pages/Home";
import TradePage from "./pages/TradePage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminUserTrades from "./pages/AdminUserTrades";
import UserTradeHistory from "./pages/UserTradeHistory";
import AboutUs from "./pages/AboutUs";
import RegisterWithOTP from './pages/RegisterWithOTP'; // Adjust the path if different
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import ForgotPassword from "./pages/ForgotPassword"; // adjust path if needed
import PaymentGatewayPage from "./pages/PaymentGatewayPage";
import AppNotificationBanner from "./components/AppNotificationBanner";
import { initPushNotifications } from "./utils/pushNotificationHandler";

function PushNotificationSubscriber() {
  const navigate = useNavigate();

  useEffect(() => {
    initPushNotifications(navigate);
  }, [navigate]);

  return null;
}

function App() {
  useEffect(() => {
    document.addEventListener("contextmenu", (e) => e.preventDefault());

    document.onkeydown = function (e) {
      if (
        e.key === "F12" ||
        (e.ctrlKey && e.shiftKey && e.key === "I") ||
        (e.ctrlKey && e.shiftKey && e.key === "J") ||
        (e.ctrlKey && e.key === "U")
      ) {
        e.preventDefault();
        return false;
      }
    };
  }, []);

  return (
    <Router>
      {/* 🔔 Native & Web Push Notification Subscriber */}
      <PushNotificationSubscriber />

      {/* 📲 One-time App Notification Banner */}
      <AppNotificationBanner />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/trade/:metalKey/:action" element={<TradePage />} />
        <Route path="/payment/:tradeId" element={<PaymentGatewayPage />} />

        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/user/:userId/trades" element={<AdminUserTrades />} />
        <Route path="/trades" element={<UserTradeHistory />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/register" element={<RegisterWithOTP />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />  
          <Route path="/forgot-password" element={<ForgotPassword />} />

      </Routes>
    </Router>
  );
}

export default App;


